import { FETCH_ALL_DISTRICTS } from "../../constants";

export default function (state = [], action) {
  switch(action.type){
    case FETCH_ALL_DISTRICTS:
      return action.districts;
    default:
      return state;
  }
}